import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.active[50]}`,
  },
  paddingDefault: {
    padding: '15px 24px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  paddingNone: {
    padding: '0',
  },
  empty: {
    padding: '30px 24px',
    textAlign: 'center',
  },
  fullHeight: {
    height: '100%',
    boxSizing: 'border-box',
  },
});

const SectionBody = ({
  classes, children, padding, empty, fullHeight, className,
}) => (
  <Paper
    className={classNames(className, classes.root, {
      [classes.paddingDefault]: padding === 'default',
      [classes.paddingNone]: padding === 'none',
      [classes.fullHeight]: fullHeight,
      [classes.empty]: empty,
    })}
  >
    {children}
  </Paper>
);

SectionBody.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.oneOf(['default', 'none']),
  empty: PropTypes.bool,
  className: PropTypes.string,
  fullHeight: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

SectionBody.defaultProps = {
  padding: 'default',
  empty: false,
  fullHeight: false,
  className: '',
};

export default withStyles(styles)(SectionBody);



// WEBPACK FOOTER //
// ./src/components/common/Section/SectionBody.js